var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?[_vm._t("loading",[_c('dotted-spinner-loader')])]:(_vm.error)?[_vm._t("error",[_c('error-handler',_vm._g({attrs:{"error":_vm.error}},_vm.$listeners))],null,{ error: _vm.error })]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }